import React from 'react'

import { getEntity, getHeaderData, getFooterData } from '@api/index'

import { default as normalizeHeaderData } from '@models/Header'
import { default as normalizeFooterData } from '@models/Footer'
import { default as normalizeArchiveFAQ } from '@models/ArchiveFaq'
import { default as normalizeBreadcrumb } from '@models/Breadcrumb'
import normalizeMetadata from '@models/Metadata'

import { Col, Container, Row } from '@/atoms/Grid'
import Breadcrumb from '@/molecules/Breadcrumb'
import { ArchiveList, ArchiveSidebar } from '@/organisms'
import Layout from '@/organisms/Layout'

export const getStaticProps = async ({ params }) => {
  const [header, footer, faq] = await Promise.all([
    getHeaderData(),
    getFooterData(),
    getEntity({ entity: 'faq' }),
  ])

  return {
    props: {
      metadata: normalizeMetadata(faq.data.seo),
      breadcrumb: normalizeBreadcrumb([{ label: 'FAQ' }]),
      footer: normalizeFooterData(footer),
      header: normalizeHeaderData(header),
      content: normalizeArchiveFAQ(faq.data),
    },
  }
}

const ArchiveFAQ = ({ metadata, breadcrumb, header, footer, content }) => {
  return (
    <Layout
      metadata={metadata}
      headerData={header}
      footerData={footer}
      colorScheme='primaryLight'
    >
      <Breadcrumb items={breadcrumb} />
      <Container>
        <Row>
          <Col
            xs={12}
            lg={4}
          >
            <ArchiveSidebar
              {...content.sidebar}
              entity='faq'
            />
          </Col>
          <Col
            xs={12}
            lg={8}
          >
            <ArchiveList
              {...content.list}
              entity='faq'
              ctaLabel='Tutte le F.A.Q'
              minimizedList
            />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export default ArchiveFAQ
